import { render, staticRenderFns } from "./IconNotifications.vue?vue&type=template&id=3537b8dc&"
import script from "./IconNotifications.vue?vue&type=script&lang=js&"
export * from "./IconNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3537b8dc')) {
      api.createRecord('3537b8dc', component.options)
    } else {
      api.reload('3537b8dc', component.options)
    }
    module.hot.accept("./IconNotifications.vue?vue&type=template&id=3537b8dc&", function () {
      api.rerender('3537b8dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconNotifications.vue"
export default component.exports